module.exports = __webpack_public_path__ + "img/logo-icon-app.e58147e3.png";